import {
    mapActions,
    mapGetters
  } from 'vuex'
  
  export default {
    data () {
      const columns = [
        {
          prop: 'title',
          scopeType: 'link'
        },
        {
          prop: 'author',
          label: '提问人：',
          scopeType: 'link'
        },
        {
          prop: 'datetime',
          // label: '提问时间：',
          scopeType: 'timeformat',
          timeformat: 'YYYY-MM-DD HH:mm:ss',
          icon: 'shijian',
          // iconLeft: '35px'
        }
      ]
      
      const comments = [
        {
          prop: 'detail',
          label: '提问：',
          showComment: 'detail',
        }
      ]
      return {
        headers: {
          title: '操作说明',
          showAlertIcon: true,
          content: '操作说明'
        },
        list: {
          api: 'fetchQuestionPage',
          loading: false,
          showComment: false,
          showClose: true,
          // title: 'close',
          columns,
          statusList: [],
          comments,
          commentsNum: [],
          footButtons: [],
          data: [],
          showCheckAll: 'head',
          params: {
            author: '',
            close: '',
            timeStart: '',
            timeEnd: '',
          },
          pageNo: 1,
          pageSize: 10,
          totalCount: 0,
          ids: []
        },
        listParams: {
          author: '',
          close: '',
          datetime:[]
        },
        searchHeader: {
          searchItems: [
            {
              type: 'dataPicker',
              value: 'datetime',
              label: '提问时间：',
              startText: '开始日期',
              endText: '结束日期'
            },
            {
              type: 'select',
              value: 'close',
              placeholder: '请选择',
              label: '开启评论：',
              style: {
                width: '120px'
              },
              options: [
                {
                  label: '所有',
                  value: ''
                },
                {
                  label: '是',
                  value: '0'
                },
                {
                  label: '否',
                  value: '1'
                }
              ]
            },
            {
              type: 'searchInput',
              label: '提问人：',
              value: 'author',
              placeholder: '请输入提问人',
            },
          ]
        },
        causeTitle: '编辑回复',
        causeForm: {
        },
        causeRules: {
          replytText: [this.$rules.required()]
        },
        causeFormItems: [
          {
            prop: 'replytText',
            type: 'textarea',
            autosize: { minRows: 3 },
            maxlength: 150
          }
        ],
        causeButtons: [
          {
            text: '确定',
            type: 'Submit'
          }
        ],
        rowId: '',
        reportNum: null
      }
    },
    computed: {
      ...mapGetters(['siteExtendConfig']),
      commentAudit () {
        return this.siteExtendConfig && this.siteExtendConfig.cfg ? this.siteExtendConfig.cfg.commentAudit : '0'
      },
      header () {
        return {
          showAlertIcon: false,
          buttons: [
            {
              type: 'All',
              btn: 'Open',
              text: '开启评论',
              icon: 'gouxuan2',
              disabled: !this._checkPermission('/myQuestion/open', 'PUT')
            },
            {
              type: 'All',
              btn: 'Close',
              text: '关闭评论',
              icon: 'guanbi',
              disabled: !this._checkPermission('/myQuestion/close', 'PUT')
            },
            {
              type: 'All',
              btn: 'Delete',
              text: '删除',
              icon: 'delete',
              disabled: !this._checkPermission('/myQuestion', 'DELETE')
            },
          ]
        }
      },
      footButtons () {
        const that = this
        return [
          {
            type: 'Answers',
            icon: 'liulan',
            text: '查看回答',
            // hiddenKey: 'answers',
            // hiddenValue: false,
            // disabled: !this._checkPermission('/letter/reply', 'PUT')
          },
          {
            type: 'Open',
            icon: 'gouxuan2',
            text: '开启评论',
            disabled: !this._checkPermission('/myQuestion/open', 'PUT')
          },
          {
            type: 'Close',
            icon: 'guanbi',
            text: '关闭评论',
            disabled: !this._checkPermission('/myQuestion/close', 'PUT')
          },
          {
            type: 'Delete',
            icon: 'delete',
            text: '删除',
            disabled: !this._checkPermission('/myQuestion', 'DELETE')
          }
        ]
      }
    },
    methods: {
      ...mapActions('config', ['FetchSiteExtentConfig'])
    },
    mounted () {
      this.FetchSiteExtentConfig()
    }
  }
  